import { TOOLKIT, TOOLKIT_INTRO, TOOLKIT_HIGHLIGHT } from "../../config/landingConfig";
import { Reveal } from "./Reveal";
import { SectionTag } from "./decorations";

const ITEM_COLORS = [
  "bg-cyan text-ink",
  "bg-magenta text-white",
  "bg-violet text-white",
];

export const Toolkit = () => (
  <section data-testid="toolkit-section" className="border-y-4 border-ink bg-violet">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-28">
      <Reveal>
        <SectionTag number="06" label="Zawartość kursu" color="bg-cyan" />
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 max-w-3xl text-2xl font-extrabold uppercase tracking-tight text-white sm:text-3xl lg:text-4xl">
          Co znajdziesz w kursie?
        </h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg">
          {TOOLKIT_INTRO}
        </p>
      </Reveal>

      <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {TOOLKIT.map((item, i) => (
          <Reveal key={item.title} delay={(i % 3) * 0.08} className="h-full">
            <li
              data-testid={`toolkit-item-${i + 1}`}
              className="hover-lift flex h-full items-start gap-4 rounded-2xl border-2 border-ink bg-white p-5 shadow-hard-sm"
            >
              <span className={`font-display flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border-2 border-ink text-lg ${ITEM_COLORS[i % 3]}`}>
                {i + 1}
              </span>
              <span>
                <span className="block text-sm font-extrabold leading-snug text-ink sm:text-base">
                  {item.title}
                </span>
                <span className="mt-1 block text-sm leading-relaxed text-ink/70">
                  {item.desc}
                </span>
              </span>
            </li>
          </Reveal>
        ))}
        <Reveal delay={0.2} className="h-full">
          <li
            data-testid="toolkit-highlight"
            className="flex h-full items-start gap-4 rounded-2xl border-2 border-ink bg-magenta p-6 shadow-hard sm:col-span-2 lg:col-span-3"
          >
            <span className="font-display flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border-2 border-ink bg-cyan text-lg text-ink">
              →
            </span>
            <p className="text-base leading-relaxed text-white sm:text-lg">
              <strong className="font-extrabold uppercase tracking-wide">
                {TOOLKIT_HIGHLIGHT.title}.{" "}
              </strong>
              {TOOLKIT_HIGHLIGHT.desc}
            </p>
          </li>
        </Reveal>
      </ul>
    </div>
  </section>
);
